<small class="debug">{{ me }}</small>
@if (dynamicsInitialized) {
    <div class="settings-section">
        <!-- Padding Section -->
        <div class="properties-section">
            <div class="prop-section-header">
                <mat-icon class="prop-section-icon">padding</mat-icon>
                <span class="prop-section-title">padding</span>
            </div>

            <div class="section-content">
                <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
                </dynamic-form>
            </div>
        </div>
    </div>
}
